export default __webpack_public_path__ + "img/dfWWqZht.29890805.svg";